import classNames from 'classnames';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';

import { resetWildlife, WildlifeClass, ThreatLevel } from '~app/actions/wildlife';

import Divider from './Divider';
import PerfectScrollbarContainer from './PerfectScrollbarContainer';
import WildlifeCitations from './WildlifeCitations';
import WildlifeClassification from './WildlifeClassification';
import WildlifeClassSelector from './WildlifeClassSelector';
import WildlifeDescription from './WildlifeDescription';
import WildlifeDetailsHeader from './WildlifeDetailsHeader';
import WildlifeImageContainer from './WildlifeImageContainer';
import WildlifeThreatCell from './WildlifeThreatCell';
import WildlifeSpeciesList from './WildlifeSpeciesList';

class Wildlife extends Component {

  componentWillMount() {
    this.props.resetWildlife(this.props.wildlifeContext, this.props.species, WildlifeClass.mammal, ThreatLevel.all);
  }

  render() {
    return (
      <div className="Wildlife">
        <div className="Wildlife__selectionSection">
          <WildlifeClassSelector
            wildlifeContext={this.props.wildlifeContext}
          />
          <Divider />
          <WildlifeThreatCell
            wildlifeContext={this.props.wildlifeContext}
          />
          <Divider />
          <WildlifeSpeciesList
            wildlifeContext={this.props.wildlifeContext}
          />
        </div>

        <Divider
          vertical={true}
          styleName="Wildlife__mainSectionDivider"
        />

        <PerfectScrollbarContainer
          horizontalScroll={true}
          verticalScroll={false}
        >
          <div className="Wildlife__contentSection">

            {!this.props.compact && this.renderSummary()}

            <div className={classNames("Wildlife__detailsSection", {
                "Wildlife__detailsSection--full": !this.props.compact,
                "Wildlife__detailsSection--compact": this.props.compact,
              })}
            >
              <WildlifeDetailsHeader
                selectedSpeciesContent={this.props.selectedSpeciesContent}
              />
              <PerfectScrollbarContainer
                horizontalScroll={false}
                verticalScroll={true}
              >
                {this.props.compact && this.renderSummary()}
                <WildlifeDescription
                  selectedSpeciesContent={this.props.selectedSpeciesContent}
                />
                <WildlifeCitations
                  selectedSpeciesSummary={this.props.selectedSpeciesSummary}
                  selectedSpeciesContent={this.props.selectedSpeciesContent}
                />
              </PerfectScrollbarContainer>
            </div>

          </div>
        </PerfectScrollbarContainer>
      </div>
    );
  }

  // The summary needs to change its structural location based on the compact
  // flag. It is grouped with other content depending on the flag value.
  renderSummary() {
    return (
      <div className={classNames("Wildlife__summarySection", {
          "Wildlife__summarySection--compact": this.props.compact,
        })}
      >
        <WildlifeImageContainer
          selectedSpeciesContent={this.props.selectedSpeciesContent}
          selectedSpeciesImage={this.props.selectedSpeciesImage}
        />
        <WildlifeClassification
          selectedSpeciesSummary={this.props.selectedSpeciesSummary}
          selectedSpeciesContent={this.props.selectedSpeciesContent}
        />
      </div>
    );
  }
}

Wildlife.propTypes = {
  species: PropTypes.array,
  compact: PropTypes.bool.isRequired,
  wildlifeContext: PropTypes.string.isRequired,
  selectedSpeciesSummary: PropTypes.object,
  selectedSpeciesContent: PropTypes.object,
};

const mapStateToProps = (state, {wildlifeContext}) => ({
  selectedSpeciesSummary: state.wildlife[wildlifeContext].selectedSpeciesSummary,
  selectedSpeciesContent: state.wildlife[wildlifeContext].selectedSpeciesContent,
  selectedSpeciesImage: state.wildlife[wildlifeContext].selectedSpeciesImage,
});

const mapDispatchToProps = {
  resetWildlife,
};

export { Wildlife };
export default connect(mapStateToProps, mapDispatchToProps)(Wildlife);



// WEBPACK FOOTER //
// ./src/components/Wildlife.js